import React, { useEffect, useState, useContext } from 'react';
import DefaultDashboard from './dashboard/DefaultDashboard';
import PolarCareDashboard from './dashboard/PolarCareDashboard';
import ClientDashboard from './dashboard/ClientDashboard';
import ProfileContext from '../../services/profileContext';
 
export default function HomePage (){
    const base_root = window.location.host
    const {
        account
    } = useContext(ProfileContext);

    if(base_root === "polarcare.polar-air.com" || base_root === "polarcare-staging.polar-air.com"){
        return <PolarCareDashboard />
    }

    if(account?.user.type === 'customer'){
        return <ClientDashboard />
    }
        
    return <DefaultDashboard />
}